document.addEventListener("DOMContentLoaded", () => {
    const productForm = document.querySelector(".product-details .product-page-add-to-cart");
    const formButtons = document.querySelector(".product-details .product-page-add-to-cart add-to-cart-component");
  
    if (!productForm || !formButtons) return;
  
    // Apply form height on load
    productForm.style.height = productForm.offsetHeight + "px";
  
    function checkFormVisibility() {
      const rect = productForm.getBoundingClientRect();
      const inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
  
      if (inView) {
        // formButtons.classList.remove("fixed");
      } else {
        formButtons.classList.add("fixed");
      }
    }
  
    // Run on load + scroll + resize
    checkFormVisibility();
    window.addEventListener("scroll", checkFormVisibility);
    window.addEventListener("resize", checkFormVisibility);
  });
  